import { render, staticRenderFns } from "./ProgramPlug.vue?vue&type=template&id=49a737c0&scoped=true"
import script from "./ProgramPlug.vue?vue&type=script&lang=js"
export * from "./ProgramPlug.vue?vue&type=script&lang=js"
import style0 from "./ProgramPlug.vue?vue&type=style&index=0&id=49a737c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a737c0",
  null
  
)

export default component.exports